module.exports = __webpack_public_path__ + "img/pauli-z-root-31.038f4c14.svg";